// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__bBSpB","sendOtp":"AuthorizeToLogin_sendOtp__NSzlJ"};